/**
 * Retry for a LightReach read. The service answers a missing quote, contract,
 * application or account with a "not found" error; that is an answer, not a
 * transient failure, so only other failures retry, thrice.
 */
export const retryLightReachRead = (
  failureCount: number,
  error: Error,
): boolean => !error.message.includes(`not found`) && failureCount < 3
